const wowApp = require('angular').module('wowApp.shop');

wowApp
    .service('SecureUserAccountService', ['$rootScope', '$state', require('./secure-user-account-service')])
    .directive('bwsSecureUserAccountForm', ['$state', '$sce', 'LoginService', 'ResetPasswordService', 'PasswordValidationService', require('./secure-user-account-form-directive')])
    .directive('bwsSecureUserAccountConfirmation', ['$state', require('./secure-user-account-confirmation-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/secure-user-account/index.js
 **/